import {
  Accordion as MuiAccordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  styled,
  Typography,
} from '@mui/material';

export const SearchWrapper = styled('div')`
  padding: 20px 0;
`;

export const Accordion = styled(MuiAccordion)`
  &.Mui-disabled {
    background-color: inherit;
  }
`;

export const Summary = styled(AccordionSummary)(
  ({ theme }) => `
        padding: 0;
        height: 35px;
        min-height: 35px;
        border-bottom: 1px solid ${theme.palette.brand.black};

        & .MuiAccordionSummary-content {
            margin: 0;
        }

        &.Mui-disabled {
          opacity: 1;
        }
    `,
);

export const Details = styled(AccordionDetails)`
  max-height: 16rem;
  overflow-y: auto;
`;

export const SummaryLabel = styled(Typography)(
  () => `
        font-weight: 500;
        font-size: 1rem;
    `,
);

export const HeaderContainer = styled(Box)(
  ({ theme }) => `
  height: 41px;
  display:flex;
  justify-content:space-between;
  align-items:center;
  border-bottom: 1px solid ${theme.palette.brand.black};
`,
);

export const FilterAccordionWrapper = styled(Box)`
  height: 75vh;
  overflow-y: auto;
`;
